module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_6000.67b2f461.png";